module.exports = __webpack_public_path__ + "img/glasses-round.68f7472c.svg";